import { useMutation } from "@apollo/client/react"; 
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from "@mui/material";
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { CustomButton } from '../../../components/customButton/CustomButton';
import { useGetColumns } from '../hooks/useGetColumns';
import { useGetRows } from '../hooks/useGetRows';
import { CabeceraContratoContent } from '../../MisVisitasContrato/components/CabeceraContratoContent';
import { NewNotificationModal } from './NewNotificationModal';
import { READ_NOTIFICATION_VISITA } from "../../../data/graphQL/mutations/Visitas/markReadNotification";
import CardBox from "../../MisVisitasCreation/components/components/CardBox/CardBox";

export const NotificacionesContent = () => {
  const [infoGeneral, setInfoGeneral] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [openModalObservacion, setOpenModalObservacion] = useState(false);
  const [observacion, setObservacion] = useState('');

  const location = useLocation();

  const { idEvaluacion, idProfesional } = location.state;

  const [readNotification, { loading: readLoading }] = useMutation(READ_NOTIFICATION_VISITA, { fetchPolicy: 'no-cache' });

  const handleReadNotification = (idNotificacion) => {
    readNotification({ variables: { idNotificacion } });
  };

  const {
    notificaciones,
    setNotificaciones,
    cabecera,
    loading,
    totalCount,
    handleSearch
  } = useGetRows(idEvaluacion);

  const handleOpenObservacionModal = (idNotificacion, observacion) => {
    setObservacion(observacion);
    handleReadNotification(idNotificacion);
    setOpenModalObservacion(true);
  };

  const columns = useGetColumns(handleOpenObservacionModal);

  useEffect(() => {
    setInfoGeneral(cabecera);
  }, [cabecera]);

  const handleCloseObservacionModal = () => {
    setOpenModalObservacion(false);
    setObservacion('');
  };

  return <div className='grid-container requisitos-clientes-grilla'>
    <CabeceraContratoContent
      infoGeneral={infoGeneral}
      profesionales={[]}
      misVisitas={false}
      notNotifications={false}
      idProfesionalSelected={0}
      setIdProfesionalSelected={() => { }}
    />
    <CardBox>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <CustomButton
          onClick={() => setOpenModal(true)}
          size='small'
          variant='outlined'>

          Nueva
        </CustomButton>
      </div>
      <DataGridGenerico
        entityId={'idNotificacion'}
        columns={columns}
        totalCount={totalCount}
        rows={notificaciones}
        toolbar={false}
        loading={loading}
      />
    </CardBox>

    <CustomDialog
      open={openModalObservacion}
      onBackdropClick={handleCloseObservacionModal}
      title="Observación"
      maxWidth="sm"
      fullWidth
    >
      <IconButton
        onClick={handleCloseObservacionModal}
        sx={{
          display: 'block',
          position: 'absolute',
          top: '4px',
          right: '8px'
        }}
      >
        <CloseIcon />
      </IconButton>
      <p>{observacion}</p>
    </CustomDialog>

    <NewNotificationModal
      openModal={openModal}
      setOpenModal={setOpenModal}
      cabecera={cabecera}
      handleSearch={handleSearch}
    />
  </div>;
};